var __WEBPACK_NAMESPACE_OBJECT__ = window.React || window.require && window.require('react');